export default __webpack_public_path__ + "static/media/3_english.42d58e02.jpg";